import { useContext } from "react";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useQuery } from "@tanstack/react-query";

const default_env_values = {
  TYPESENSE_HOST: process.env.TYPESENSE_HOST,
  TYPESENSE_PORT: process.env.TYPESENSE_PORT,
  TYPESENSE_ENV: process.env.TYPESENSE_ENV,
  NODE_ENV: process.env.NODE_ENV,
};

export const useEnvironmentVariables = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["all_EvironmentVariables"],
    queryFn: () => {
      return appAxios
        .get("/api/environment-variables/")
        .then((res) => ({ ...default_env_values, ...res.data }));
    },
    cacheTime: 3600000,
    staleTime: 3600000,
  });
};

export default useEnvironmentVariables;
